import { careers } from '@/utils/careers';

export type CareerMetadata = {
  icon: string;
  color: string;
  label: string;
};

/* eslint-disable camelcase */
const CAREER_ICON_COLOR: Record<string, { icon: string; color: string }> = {
  caregiver: { icon: 'mdi-account-heart', color: 'blue-grey' },
  nurse_technician: { icon: 'mdi-stethoscope', color: 'teal' },
  nurse: { icon: 'mdi-hospital-box', color: 'light-blue' },
  auxiliary_nurse: { icon: 'mdi-account-supervisor', color: 'cyan' },
  occupational_therapist: { icon: 'mdi-hand-heart', color: 'deep-purple' },
  kinesiologist: { icon: 'mdi-human-handsup', color: 'indigo' },
  phonoaudiologist: { icon: 'mdi-microphone', color: 'pink' },
  doctor: { icon: 'mdi-doctor', color: 'red' },
  podologist: { icon: 'mdi-foot-print', color: 'brown' },
  psychologist: { icon: 'mdi-brain', color: 'purple' },
  massagist: { icon: 'mdi-hand-extended', color: 'orange' },
  personal_assistant: { icon: 'mdi-account-tie', color: 'grey' },
  dietitian: { icon: 'mdi-food-apple', color: 'green' },
  midwife: { icon: 'mdi-baby-face', color: 'pink-lighten-1' },
  supervising_nurse: { icon: 'mdi-account-star', color: 'blue' },
};
/* eslint-enable camelcase */

const FALLBACK = { icon: 'mdi-account-circle', color: 'grey' };

export function careerMetadata(career: string, humanCareer?: string): CareerMetadata {
  const meta = CAREER_ICON_COLOR[career] || FALLBACK;
  return { ...meta, label: humanCareer || career };
}

export const ALL_CAREERS = Object.keys(CAREER_ICON_COLOR);

// Labels come from the shared careers list (the same names as the backend's
// es-CL translations), never from a local copy that can drift.
export function careerLabel(career: string): string {
  return careers.find((option) => option.value === career)?.title ?? career;
}
